module.exports = __webpack_public_path__ + "media/styles/images/svg/checkbox-unchecked-teal-9ec792247f165e93a9259f343caddd1e.svg";